import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class QuestionTemplateStatusRelation implements MutableValue {
  public isNew = true;

  constructor(
    private fId: string,
    private fTemplate: string,
    private fPlushieStatus: string
  ) {
    [fId, fTemplate, fPlushieStatus].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get template(): string {
    return this.fTemplate;
  }

  get plushieStatus(): string {
    return this.fPlushieStatus;
  }
}
